// URL of the alt.co API root
// staging: 'https://api-staging.alt.co/api/v1'
// prod:    'https://api.alt.co/api/v1'
export const API_ROOT = "https://api.alt.co/api/v1";

// Application name used in page title and welcome message
export const APP_NAME = "chukkerCoin";

// Server prefix where videoconferences are hosted
export const CONFERENCE_HOST_NAME = "https://onboarding.alt.co";

// List of projects to be displayed on the frontend (null to display every available projects). You can use either the slugs or the project ids.
// Example:
//    * export const PROJECTS_TO_DISPLAY = ["5d1e0d09ca410c150c207d94", "5d1e0d09ca410c150c207d95"];
//    * export const PROJECTS_TO_DISPLAY = ["demo-1", "your-project-slug"];

export const PROJECTS_TO_DISPLAY = ["689206dbbd80ab9fc30f5f93"];
